import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useInvitationService } from "../../../hooks/useInvitationService";
import { activityQueryKeys } from "../constants";
import type { JoinRequestMeta } from "../types";

/** Accepts a join request with a given role and invalidates activity queries. */
export function useAcceptJoinRequestMutation(meta: JoinRequestMeta) {
    const invitationService = useInvitationService();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (role: string) =>
            invitationService.respondToWorkspaceJoinRequest(
                meta.workspaceId,
                meta.requestId,
                role,
                "accept"
            ),
        onSettled: () => queryClient.invalidateQueries({ queryKey: activityQueryKeys.all })
    });
}
